var defaultChunkSize = 1024 * 1024 * 4;

function characterDataProxy(data) {
    this.data = data;
    this.length = data.length;
    this.isString = (typeof data === 'string');
}

characterDataProxy.prototype.substringData = function (offset, count) {
    return this.isString ? this.data.substring(offset, offset + count) : this.data.substringData(offset, count);
}

characterDataProxy.prototype.charAt = function (index) {
    return this.isString ? this.data.charAt(index) : this.data.substringData(index, 1);
}

/**
 * Convert base64 encoded data into the Blob object
 * 
 * @param {string|CharacterData|Array} b64Data Base64 encoded string, CharacterData, data URL or array
 * @param {string} contentType 
 * @param {number} [chunkSize=4194304]
 * @returns Promise
 */
function b64ToBlob(b64Data, contentType, chunkSize) {
    var type = contentType;

    var b64Array = Array.isArray(b64Data) ? b64Data : [b64Data];

    return Promise.all(
        b64Array.map(function (b64) {
            var b64Data = new characterDataProxy(b64);
            var start = 0;
            if (b64Data.substringData(0, 5) === 'data:') {
                start = 5;
                while (b64Data.charAt(start++) !== ',');

                var header = b64Data.substringData(5, start - 6);
                if (!type) {
                    type = header.replace(/(;base64)?,/, '');
                }

                if (header.indexOf(';base64') < 0) {
                    for (var i = start; i < b64Data.length; i += chunkSize) {
                        result.push(b64Data.substringData(i, Math.min(chunkSize, b64Data.length - i)));
                    }
                    return Promise.resolve(result);
                }
            }
            return b64ToArray(b64, start);
        })
    )
        .then(function (a) {
            return new Blob(a.flat(), { type: type });
        })
}


/**
 * Convert base64 encoded data into the array of chunks
 * 
 * @param {string|CharacterData} b64Data Base64 encoded string or CharacterData
 * @param {number} start
 * @param {number} [chunkSize=4194304]
 * @returns Promise
 */
function b64ToArray(b64Data, start, chunkSize) {
    return new Promise(function (resolve, reject) {
        function workerCode() {
            function characterDataProxy(data) {
                this.data = data;
                this.length = data.length;
                this.isString = (typeof data === 'string');
            }
            characterDataProxy.prototype.substringData = function (offset, count) {
                return this.isString ? this.data.substring(offset, offset + count) : this.data.substringData(offset, count);
            }
            characterDataProxy.prototype.charAt = function (index) {
                return this.isString ? this.data.charAt(index) : this.data.substringData(index, 1);
            }
            var self = this;
            self.onmessage = function (e) {
                var b64Data = new characterDataProxy(e.data[0]),
                    start = e.data[1],
                    chunkSize = e.data[2],
                    result = [];
                for (var i = start; i < b64Data.length;) {
                    var s = b64Data.substringData(i, Math.min(chunkSize, b64Data.length - i)).replace(/[\s\n]+/g, '');
                    i += chunkSize;
                    while ((s.length < chunkSize) && (i < b64Data.length)) {
                        s += b64Data.charAt(i++).replace(/[\s\n]/, '');
                    }
                    var chunk = atob(s);
                    var bytes = new Array(chunk.length);
                    for (var j = 0; j < chunk.length; j++) {
                        bytes[j] = chunk.charCodeAt(j);
                    }
                    result.push(new Uint8Array(bytes));
                }
                self.postMessage(result);
            };
        }

        var param = [b64Data, start, chunkSize || defaultChunkSize];

        try {
            var code = ('(' + workerCode + ')();').replace('"use strict";', ''),
                src = URL.createObjectURL(new Blob([code], { type: 'application/javascript' })),
                worker = new Worker(src);
                URL.revokeObjectURL(src);
            worker.onmessage = function (e) {
                resolve(e.data);
                worker.terminate();
            };
            worker.postMessage(param);
        } catch (e) {
            try {
                var self = { postMessage: resolve };
                workerCode.call(self);
                self.onmessage({ data: param });
            } catch (e) {
                reject(e);
            }
        }
    });
}

module.exports = b64ToBlob;